import { createAsyncThunk } from "@reduxjs/toolkit"

import { clearLocalStorage } from "src/localStorage"

export const logoutUser = createAsyncThunk("auth/logout", async (_, { dispatch }) => {
  try {
    dispatch({ type: "user/reset" })
    dispatch({ type: "messages/reset" })
    dispatch({ type: "lobby/reset" })
    dispatch({ type: "game/reset" })
    // A balance belongs to an account, so it leaves with it. Left behind, the next player to sign
    // in on this browser sees somebody else's credits until their own wallet loads.
    dispatch({ type: "economy/reset" })
    clearLocalStorage()
    return true
  } catch (error) {
    console.error("Logout Failed:", error)
    throw error
  }
})
